<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<div>
  <mat-sidenav-container>
    <router-outlet></router-outlet>
  </mat-sidenav-container>
</div>